import * as Yup from 'yup';
import { REQUIRED_ERROR_MSG } from 'utils/constants/errors';

export const goalsSchema = Yup.object().shape({
  calories: Yup.number().integer().required(REQUIRED_ERROR_MSG),
  carbs: Yup.number().integer().required(REQUIRED_ERROR_MSG),
  fat: Yup.number().integer().required(REQUIRED_ERROR_MSG),
  protein: Yup.number().integer().required(REQUIRED_ERROR_MSG),
  water: Yup.number().required(REQUIRED_ERROR_MSG),

  minutes: Yup.number().integer().required(REQUIRED_ERROR_MSG),

  type: Yup.string().required(REQUIRED_ERROR_MSG),

  due_date: Yup.date().required(REQUIRED_ERROR_MSG).nullable(),

  exercise: Yup.string().when('type', {
    is: "Strength",
    then: Yup.string().required(REQUIRED_ERROR_MSG),
  }),
  exercise_name: Yup.string().when('type', {
    is: "Strength",
    then: Yup.string().required(REQUIRED_ERROR_MSG),
  }),
  max_lift: Yup.number().when('type', {
    is: "Strength",
    then: Yup.number().required(REQUIRED_ERROR_MSG),
  }),


  description: Yup.string().when('type', {
    is: (val) => !val || val === 'Other',
    then: Yup.string().required(REQUIRED_ERROR_MSG),
  }),
  goal: Yup.number().positive().moreThan(0).when('type', {
    is: (val) => !val || val === 'Other',
    then: Yup.number().positive().moreThan(0).required(REQUIRED_ERROR_MSG),
  }),
  goal_unit: Yup.string().when('type', {
    is: (val) => !val || val === 'Other',
    then: Yup.string().required(REQUIRED_ERROR_MSG),
  }),


}).test('', null, values => {
  if ((values.type === "Other" && (!values.due_date || !values.goal || !values.goal_unit
  && !values.description))
    ||
  (values.type === "Strength" && (!values.exercise || !values.exercise_name || !values.max_lift
  && !values.due_date))) {
    return new Yup.ValidationError(
      REQUIRED_ERROR_MSG,
      null,
      'strengthMod'
    );
  }

  // Add nutration goal model
  if(!values.calories || !values.carbs || !values.fat || !values.protein || !values.water) {
    return new Yup.ValidationError(
      true,
      null,
      'addNutrationGoalModel'
    );
  }
  return true;
});

